import { lazy, Suspense } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { useMemoryMapEnabled } from '../hooks/useMemoryMapEnabled';

const MemoryMapPage = lazy(() => import('../pages/MemoryMapPage'));

const mapFallback = (
  <div
    className="flex min-h-screen items-center justify-center bg-workspace-surface-50 text-workspace-text-secondary"
    role="status"
    aria-live="polite"
  >
    Loading…
  </div>
);

/**
 * Renders Memory Map when PostHog (or local override) allows it; otherwise redirects to the memories list.
 * Must only be mounted when PostHogProvider is present (useFeatureFlagEnabled).
 */
export default function MemoryMapRouteGate() {
  const { pathname } = useLocation();
  const { enabled } = useMemoryMapEnabled();
  const listPath = pathname.startsWith('/workspace') ? '/workspace' : '/spaces/memories';

  if (!enabled) {
    return <Navigate to={listPath} replace />;
  }

  return (
    <Suspense fallback={mapFallback}>
      <MemoryMapPage />
    </Suspense>
  );
}
